import React, { useEffect, useState } from 'react';
import MyGoogleMap from 'components/Common/Maps/MyGoogleMap';
import { PropTypes } from 'prop-types';
import * as Yup from 'yup';
import { useNibbleForm } from 'components/Nibble/Hooks/UseNibbleForm';
import { Alert, Button, Card, CardBody, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Row } from 'reactstrap';

import { MEXICO_STATES } from 'helpers/states';
import { postDelivery, putDevelivery } from 'helpers/backend_helper';

const cpRegExp = /^[0-9]{5}/;

const DeliveryAddress = ({ model, setModel }) => {
    const [curAddress, setCurAddress] = useState({
        country: 'México',
    })
    const [offCanvasIsOpen, setOffCanvasIsOpen] = useState(false)
    const [error, setError] = useState("")
    const [completed, setCompleted] = useState("")
    const [btnSaveLoad, setBtnSaveLoad] = useState(false)
    const [position, setPosition] = useState(null)
    const [selectedRegion, setSelectedRegion] = useState(model.invoice_address?.region_id)

    const addAddress = (indexItem, edit = false) => {
        const address = indexItem != null ? model.deliveries_address[indexItem] : {}
        address.edit = edit
        address.indexItem = indexItem

        validation.setFieldValue('street', curAddress.street ?? '')
        validation.setFieldValue('ext_num', curAddress.ext_num ?? '')
        validation.setFieldValue('int_num', curAddress.int_num ?? '')
        validation.setFieldValue('cp', curAddress.cp ?? '')
        validation.setFieldValue('location', curAddress.location ?? '')
        validation.setFieldValue('city', curAddress.city ?? '')
        validation.setFieldValue('state', curAddress.state ?? '')
        validation.setFieldValue('country', curAddress.country ?? 'México')
        validation.setFieldValue('gps', curAddress.gps ?? '')

        setCurAddress(address)
        setOffCanvasIsOpen(true)
    }
    const delAddress = (indexItem) => {
        const newAddres = [...model.deliveries_address]
        newAddres.splice(indexItem, 1)
        setModel({ ...model, deliveries_address: newAddres })
    }
    const toggleRightCanvas = () => {
        setCompleted(null)
        setOffCanvasIsOpen(!offCanvasIsOpen)
    }

    const { validation, render } = useNibbleForm({
        formScheme: [
            { md: 12, name: 'street', label: 'Calle', type: 'text' },
            { md: 4, name: 'ext_num', label: 'Num. Ext.', type: 'text' },
            { md: 4, name: 'int_num', label: 'Num. Int.', type: 'text' },
            { md: 4, name: 'cp', label: 'C.P.', type: 'text' },
            { md: 6, name: 'location', label: 'Colonia', type: 'text' },
            { md: 6, name: 'city', label: 'Ciudad/Municipio', type: 'text' },
            { md: 6, name: 'state', label: 'Estado', type: 'select', selectItems: MEXICO_STATES, selectOptionValue: (option) => `${option.name}` },
            { md: 6, name: 'country', label: 'País', type: 'text', disabled: true },
            { md: 12, name: 'gps', label: 'Ubicación GPS', type: 'text' },
            { md: 12, name: 'goo_address', label: null, type: 'hidden' },
        ],
        validationScheme: Yup.object().shape({
            street: Yup.string().required('Requerido'),
            ext_num: Yup.string().required('Requerido'),
            int_num: Yup.string().nullable(),
            cp: Yup.string().matches(cpRegExp, 'Código postal no válido').required('Requerido'),
            location: Yup.string().required('Requerido'),
            city: Yup.string().required('Requerido'),
            state: Yup.string().required('Requerido'),
            country: Yup.string().required('Requerido'),
        }),
        defaultModelValues: {
            ...curAddress,
            country: 'México',
        },
        onSubmit: async (values) => {
            console.log('values', values)
            setCurAddress({ ...curAddress, ...values })
            setBtnSaveLoad(true)
            try {
                const obj = JSON.parse(localStorage.getItem("authUser"))
                console.log('user', obj.user);
                console.log('modela', { id: model.id, ...values })

                let newModel = {}
                if ('indexItem' in curAddress && curAddress.indexItem != null) {
                    const response = await putDevelivery(model.id, { id: curAddress.id, ...values, region_id: selectedRegion })
                    newModel = { ...model }
                    newModel.deliveries_address[curAddress.indexItem] = response;
                } else {
                    const response = await postDelivery(model.id, { ...values, region_id: selectedRegion })
                    newModel = { ...model }
                    newModel.deliveries_address.push(response)
                    toggleRightCanvas()
                }

                setModel(newModel)
                setError(null)
                setCompleted('Se completo la operación')
            } catch (error) {
                console.log(error)
                setError(error.toString())
                setCompleted(null)
            }
            setBtnSaveLoad(false)
        }
    });

    return (
        <>
            <Card>
                <CardBody>
                    <table className="table table-responsive table-bordered table-sm">
                        <thead>
                            <tr className='bg-light'>
                                <th>Región</th>
                                <th>Dirección</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(model.deliveries_address || []).map((address, key) => (
                                <tr key={key}>
                                    <td>{address.region?.name}</td>
                                    <td>{address.address_string}</td>
                                    <td>
                                        <Button type="button" className="btn btn-warning btn-sm" onClick={() => addAddress(key, true)}>
                                            <i className="fas fa-edit"></i>
                                        </Button> <Button type="button" className="btn btn-danger btn-sm" onClick={() => delAddress(key)}>
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            {model.deliveries_address?.length == 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center">Sin Direcciones de Entrega</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={6} className="text-center">
                                    <Button type="button" className="btn btn-danger btn-sm" onClick={() => addAddress()}>
                                        <i className="fas fa-plus"></i> Agregar dirección de entrega
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </CardBody>
            </Card>
            <Offcanvas
                isOpen={offCanvasIsOpen}
                direction="end"
                toggle={toggleRightCanvas}
            >
                <OffcanvasHeader toggle={toggleRightCanvas}>
                    {'edit' in curAddress && curAddress.edit ? 'Modificar dirección de entrega' : 'Nueva dirección de entrega'}
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit(e)
                            return false;
                        }}
                    >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        {completed ? <Alert color="success">{completed}</Alert> : null}
                        <Row>
                            {render()}
                        </Row>

                        <MyGoogleMap
                            validation={validation}
                            setPosition={setPosition}
                            setAddress={newAddress => {
                                validation.setFieldValue('goo_address', newAddress)
                            }}
                            startPosition={
                                validation.values.gps
                                    ? {
                                        lat: Number(validation.values.gps.split(",")[0]),
                                        lng: Number(validation.values.gps.split(",")[1]),
                                    }
                                    : null
                            }
                        />

                        <div className="text-center mt-3">
                            <button type="submit" className="btn btn-sm btn-danger w-md" disabled={btnSaveLoad}>
                                <i className="fas fa-save"></i> Guardar
                            </button>
                            <button type="button" className="btn btn-sm btn-danger w-md ms-2" disabled={btnSaveLoad} onClick={toggleRightCanvas}>
                                <i className="fas fa-reply"></i> Cerrar
                            </button>
                        </div>
                    </Form>
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

DeliveryAddress.propTypes = {
    model: PropTypes.object.isRequired,
    setModel: PropTypes.func.isRequired,
};

export default DeliveryAddress;